import { useIntl } from "react-intl";

import { useMutation } from "@tanstack/react-query";

import { Audits } from "../../../api/audits";
import { MutationKey } from "../../../consts/mutation-keys";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { useFetchError } from "../../../hooks/useFetchError";
import { FileResponse } from "../../../http-client";
import { ApiError } from "../../../types/api-error";
import { saveFile } from "../../../utils/save-file";

export const useDeletedItems = () => {
  const { formatMessage } = useIntl();

  const { handleSuccess } = useApiSuccess({
    snackbarText: formatMessage({
      id: "ACTION.FILE_DOWNLOAD_SUCCESS",
      defaultMessage: "File downloaded successfully.",
      description: "File download success message",
    }),
  });

  const mutationFn = () => {
    return Audits.getDeletedItems();
  };

  const {
    mutate: fetchDeletedItems,
    isPending,
    error,
  } = useMutation<FileResponse | null, ApiError>({
    mutationKey: [MutationKey.FetchFile],
    mutationFn: mutationFn,
    onSuccess: response => {
      handleSuccess();
      if (response) {
        saveFile(response);
      }
    },
  });

  useFetchError(error);

  return { fetchDeletedItems, isPending };
};
